import LinkSetUnavailableObject from 'redpoints-model-js/model/system/LinkSetUnavailableObject';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import DeindexationController from 'redpoints-restapi-connector/controller/DeindexationController';
import EnforcementComplaintWithdrawnReasonController from 'redpoints-restapi-connector/controller/EnforcementComplaintWithdrawnReasonController';
import EnforcementDisruptedReasonController from 'redpoints-restapi-connector/controller/EnforcementDisruptedReasonController';
import LinkController from 'redpoints-restapi-connector/controller/LinkController';
import SearchEngineDomainController from 'dms-restapi-connector/controller/domain/SearchEngineDomainController';

import {
  CONNECTOR_REQUEST,
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_CLEAR_RELAUNCH_ENFORCEMENT,
  LINKS_MANAGEMENT_COMPLAINT_WITHDRAWN_REASONS_FETCH,
  LINKS_MANAGEMENT_ENFORCEMENT_DISRUPTED_REASONS_FETCH,
  LINKS_MANAGEMENT_LINK_AVAILABILITY_URL_FORMAT_ERROR,
  LINKS_MANAGEMENT_LINKS_SET_CONTENT_LINKS_URLS,
  LINKS_MANAGEMENT_LINKS_SET_DETECTION_LINKS_URLS,
  LINKS_MANAGEMENT_LINKS_SET_PROCESSING_CONTENT_LINKS,
  LINKS_MANAGEMENT_LINKS_SET_PROCESSING_DETECTION_LINKS,
  LINKS_MANAGEMENT_RELAUNCH_ENFORCEMENT,
  LINKS_MANAGEMENT_SEARCH_ENGINE_FETCH,
  LINKS_MANAGEMENT_SET_LINK_AVAILABILITY,
  LINKS_MANAGEMENT_SET_LINK_BY_URL,
  LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL,
  LINKS_MANAGEMENT_URL_FORMAT_ERROR,
} from './actionTypes';
import LinkManagementService from '../services/LinkManagementService';

export const linksManagementClear = () => ({
  type: LINKS_MANAGEMENT_CLEAR,
});

export const linksManagementClearRelaunchEnforcement = () => ({
  type: LINKS_MANAGEMENT_CLEAR_RELAUNCH_ENFORCEMENT,
});

export const linksManagementLinksSetDetectionLinksUrls = ({
  detectionLinkUrls,
}) => ({
  type: LINKS_MANAGEMENT_LINKS_SET_DETECTION_LINKS_URLS,
  payload: { detectionLinkUrls },
});

export const linksManagementLinksSetContentLinksUrls = ({
  contentLinkUrls,
}) => ({
  type: LINKS_MANAGEMENT_LINKS_SET_CONTENT_LINKS_URLS,
  payload: { contentLinkUrls },
});

export const linksManagementLinksSetProcessingDetectionLinks = ({
  detectionLinks,
  newStatus,
  selectedReason,
}) => ({
  type: LINKS_MANAGEMENT_LINKS_SET_PROCESSING_DETECTION_LINKS,
  payload: { detectionLinks, newStatus, selectedReason },
});

export const linksManagementLinksSetProcessingContentLinks = ({
  contentLinks,
  newStatus,
  selectedReason,
}) => ({
  type: LINKS_MANAGEMENT_LINKS_SET_PROCESSING_CONTENT_LINKS,
  payload: { contentLinks, newStatus, selectedReason },
});

export const linksManagementUrlFormatError = ({ linkSetStatusObject }) => ({
  type: LINKS_MANAGEMENT_URL_FORMAT_ERROR,
  payload: { linkSetStatusObject },
});

export const linksManagementLinkAvailabilityUrlFormatError = ({
  linkSetUnavailableObject,
}) => ({
  type: LINKS_MANAGEMENT_LINK_AVAILABILITY_URL_FORMAT_ERROR,
  payload: { linkSetUnavailableObject },
});

export const linksManagementSetStatusLinkByUrl = ({ linkSetStatusObject }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_SET_LINK_BY_URL,
    connectorMethod: LinkController.setStatusByUrl,
    sortedParameters: [linkSetStatusObject],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
  payload: { linkSetStatusObject },
});

export const linksManagementEnforcementDisruptedReasonsFetch = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_ENFORCEMENT_DISRUPTED_REASONS_FETCH,
    connectorMethod: EnforcementDisruptedReasonController.list,
    sortedParameters: [],
    expectedStatus: HttpStatus.OK,
    mustShowErrorMessages: false,
  },
});

export const linksManagementSetDeindexationStatusByUrl = linkSetStatusObject => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_SET_LINK_DEINDEXATION_STATUS_BY_URL,
    connectorMethod: DeindexationController.setDeindexationStatusByUrl,
    sortedParameters: [linkSetStatusObject],
    expectedStatus: HttpStatus.NO_CONTENT,
    mustShowErrorMessages: false,
  },
  payload: { linkSetStatusObject },
});

export const linksManagementComplaintWithdrawnReasonsFetch = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_COMPLAINT_WITHDRAWN_REASONS_FETCH,
    connectorMethod: EnforcementComplaintWithdrawnReasonController.list,
    sortedParameters: [],
    expectedStatus: HttpStatus.OK,
    mustShowErrorMessages: false,
  },
});

export const linksManagementRelaunchEnforcement = ({
  detectionLinks,
  contentLinks,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_RELAUNCH_ENFORCEMENT,
    connectorMethod: LinkManagementService.relaunchEnforcement,
    sortedParameters: [detectionLinks, contentLinks],
    expectedStatus: HttpStatus.OK,
    mustShowErrorMessages: false,
  },
});

export const linksManagementSearchEngineFetch = () => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: LINKS_MANAGEMENT_SEARCH_ENGINE_FETCH,
    connectorMethod: SearchEngineDomainController.list,
    sortedParameters: [],
    expectedStatus: HttpStatus.OK,
    mustShowErrorMessages: false,
  },
});

export const linksManagementSetLinkAvailability = ({
  linkType,
  linkUrl,
  unavailable,
}) => {
  const linkSetUnavailableObject = new LinkSetUnavailableObject();
  linkSetUnavailableObject.unavailable = unavailable;
  linkSetUnavailableObject.linkType = linkType;
  linkSetUnavailableObject.url = linkUrl;

  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType: LINKS_MANAGEMENT_SET_LINK_AVAILABILITY,
      connectorMethod: LinkController.setAvailabilityByUrl,
      sortedParameters: [linkSetUnavailableObject],
      expectedStatus: [HttpStatus.NO_CONTENT],
      mustShowErrorMessages: false,
    },
    payload: { linkSetUnavailableObject },
  };
};
